import DirectiveTouch from './touch.js'

let installed = false

const swipePlugin = {
  install (Vue, options = {}) {
    if (installed) {
      return
    }

    Vue.directive('swipe', {
      bind (el, binding) {
        const touchCLass = new DirectiveTouch(el, binding)
        touchCLass.bind()
      }
    })
  }
}

export default swipePlugin

